import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition } from "vue"
import _imports_0 from '@/assets/img/miki_ihara_logo.svg'
import _imports_1 from '@/assets/img/sp-nav-history.svg'
import _imports_2 from '@/assets/img/sp-nav-about.svg'
import _imports_3 from '@/assets/img/sp-nav-introduction.svg'
import _imports_4 from '@/assets/img/sp-nav-access.svg'
import _imports_5 from '@/assets/img/sp-nav-link.svg'
import _imports_6 from '@/assets/img/sp-nav-privacypolicy.svg'


const _hoisted_1 = { class: "header-inner" }
const _hoisted_2 = { id: "nav-drawer" }
const _hoisted_3 = {
  key: 0,
  id: "nav-content"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("header", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_router_link, { to: { name: 'home' } }, {
        default: _withCtx(() => [
          _createElementVNode("img", {
            id: "nav-title",
            src: _imports_0,
            alt: "三木・伊原法律特許事務所",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.hide && _ctx.hide(...args)))
          })
        ]),
        _: 1
      }),
      _createElementVNode("div", {
        id: "nav-hide",
        class: _normalizeClass(_ctx.navHideClass),
        onTouchstart: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.hide && _ctx.hide(...args))),
        onMousedown: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.hide && _ctx.hide(...args)))
      }, null, 34),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          id: "nav-icon",
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.toggle && _ctx.toggle(...args)))
        }, _cache[10] || (_cache[10] = [
          _createElementVNode("span", null, null, -1)
        ])),
        _createVNode(_Transition, { name: "nav" }, {
          default: _withCtx(() => [
            (_ctx.show)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createElementVNode("ul", null, [
                    _createElementVNode("li", null, [
                      _createVNode(_component_router_link, { to: { name: 'history' } }, {
                        default: _withCtx(() => [
                          _createElementVNode("img", {
                            src: _imports_1,
                            alt: "事務所の沿革",
                            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.hide && _ctx.hide(...args)))
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_router_link, { to: { name: 'about' } }, {
                        default: _withCtx(() => [
                          _createElementVNode("img", {
                            src: _imports_2,
                            alt: "業務内容",
                            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.hide && _ctx.hide(...args)))
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_router_link, { to: { name: 'introduction' } }, {
                        default: _withCtx(() => [
                          _createElementVNode("img", {
                            src: _imports_3,
                            alt: "弁護士・弁理士紹介",
                            onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.hide && _ctx.hide(...args)))
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_router_link, { to: { name: 'access' } }, {
                        default: _withCtx(() => [
                          _createElementVNode("img", {
                            src: _imports_4,
                            alt: "アクセス",
                            onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.hide && _ctx.hide(...args)))
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_router_link, { to: { name: 'link' } }, {
                        default: _withCtx(() => [
                          _createElementVNode("img", {
                            src: _imports_5,
                            alt: "リンク",
                            onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.hide && _ctx.hide(...args)))
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_router_link, {
                        class: "link-privacy",
                        to: { name: 'privacy-policy' }
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("img", {
                            src: _imports_6,
                            alt: "プライバシーポリシー",
                            onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.hide && _ctx.hide(...args)))
                          })
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ])
    ])
  ]))
}